/**
 * Closing call-to-action (rule 11) — three ordered next steps, rendered as the
 * FINAL content block. Reads the report's injected `call_to_action`, falling back
 * to the shared default for legacy reports.
 */
import { ArrowRight } from "lucide-react";
import { DEFAULT_CTA } from "@/lib/constants";

export default function CallToActionBlock({ cta, onBook, bare = false }) {
  const data = cta && cta.items && cta.items.length ? cta : DEFAULT_CTA;
  return (
    <div
      data-testid="call-to-action-block"
      className={bare ? "" : "mt-10 rounded-xl border border-teal-200 bg-teal-50/50 p-6 sm:p-8"}
    >
      {!bare && (
        <>
          <p className="text-[11px] uppercase tracking-[0.16em] text-teal-700">Next steps</p>
          <h3 className="mt-2 font-display text-2xl font-semibold text-slate-900 tracking-tight">
            {data.heading || "Where to go from here"}
          </h3>
        </>
      )}
      <ol className={`${bare ? "" : "mt-6"} space-y-5`}>
        {data.items.map((it, i) => (
          <li key={i} className="flex gap-4" data-testid={`cta-item-${i}`}>
            <span className="shrink-0 h-7 w-7 rounded-full bg-teal-600 text-white text-sm font-semibold flex items-center justify-center">
              {i + 1}
            </span>
            <div>
              <p className="font-semibold text-slate-900">{it.title}</p>
              {it.description && <p className="mt-0.5 text-sm text-slate-700 leading-relaxed">{it.description}</p>}
            </div>
          </li>
        ))}
      </ol>
      {onBook && (
        <button
          onClick={onBook}
          data-testid="cta-book-btn"
          className="mt-6 inline-flex items-center gap-2 h-11 px-5 rounded-md bg-teal-600 text-white text-sm font-medium hover:bg-teal-500 transition-colors"
        >
          Book a session <ArrowRight className="h-4 w-4" />
        </button>
      )}
    </div>
  );
}
